<style src="./RelateTariffSchedule.scss" lang="scss"></style>
<template>
  <div class="wrapper wrapper-content animated fadeIn">
    <div class="container row">
      <div class="col-lg-4">
        <h3>Agendas Tarifárias</h3>
        <div class="mail-box">
          <table class="table table-hover table-mail">
            <thead class="table-head">
              <tr>
                <th>Nome</th>

                <th></th>
              </tr>
            </thead>

            <tbody class="table-list">
              <tr v-for="(schedule, key) in schedules" :key="key">
                <td>{{ schedule.name }}</td>
                <td class="list-command">
                  <div class="form-check">
                    <input
                      type="radio"
                      class="form-check-input"
                      :value="schedule._id"
                      v-model="selectedSchedule"
                    />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="col-lg-8">
        <div class="mail-box-header">
          <div class="row">
            <div class="form-group col-lg-6">
              <select class="form-control" v-model="selectEntity">
                <option value="UserList" selected>Usuário</option>
                <option value="VehicleList">Veículo</option>
                <option value="SpotList">Vaga</option>
                <option value="ParkList">Estacionamento</option>
                <option value="ZoneList">Zona</option>
                <option value="RoleList">Nível de Permissão</option>
                <option value="DefaultClient">Padrão</option>
              </select>
            </div>
            <header class="col-lg-6">
              <h3>Entidades</h3>
            </header>
          </div>
          <p class="info-text">
            Caso não queira mexer na tolerancia basta não enviar, a antiga não
            será alterada caso o input esteja em branco.
          </p>
        </div>
        <div>
          <component :is="selectEntity" :selected-schedule="selectedSchedule" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserList from './components/UserList/UserList';
import VehicleList from './components/VehicleList/VehicleList';
import ParkList from './components/ParkList/ParkList';
import ZoneList from './components/ZoneList/ZoneList';
import DefaultClient from './components/DefaultClient/DefaultClient';
import SpotList from './components/SpotList/SpotList';
import RoleList from './components/RoleList/RoleList';

// import { mapGetters } from 'vuex';
export default {
  components: {
    UserList,
    VehicleList,
    ParkList,
    ZoneList,
    DefaultClient,
    SpotList,
    RoleList,
  },
  data() {
    return {
      selectEntity: 'UserList',
      schedules: [],
      selectedSchedule: '',
    };
  },
  mounted() {
    this.loadTariffSchedule();
  },
  methods: {
    async loadTariffSchedule() {
      // TARIFF-SCHEDULE
      try {
        const schedules = await this.$store.dispatch(
          'TARIFF-SCHEDULE/LoadTariffSchedules',
        );
        this.schedules = schedules;
      } catch (error) {
        this.$toasted.error(error.error);
      }
    },
  },
};
</script>
